import axios from "axios";
import { ClientEvent } from "matrix-js-sdk";
import { useContext, useState } from "react";
import { Toast } from "src/components";
import { API_URL } from "src/scenes/App";
import { UserContext } from "src/scenes/App/UserContext";

export const useLeaveChat = () => {
    const currentUser = useContext(UserContext);
    const headers = { headers: { Authorization: `Bearer ${currentUser.token}` } };
    const [isLeavingChat, setIsLeavingChat] = useState(false);

    const leaveChat = async (currentChat, newOwnerEmployeeUuid) => {
        setIsLeavingChat(true);
        try {
            const url = `${API_URL}/chats/leave/${currentChat.uuid}`;
            const requestBody = newOwnerEmployeeUuid ? { newOwnerEmployeeUuid } : {};
            await axios.put(url, requestBody, headers);
            currentChat.matrixClient?.emit?.(ClientEvent.DeleteRoom, currentChat.matrixRoomId);
            Toast.success("You left the group chat.");
        } catch (error) {
            Toast.error(error.getApiErrorDetails().message);
            throw error;
        } finally {
            setIsLeavingChat(false);
        }
    };

    const requestToLeaveChat = async (chatUuid, requestingLeave) => {
        setIsLeavingChat(true);
        try {
            const url = `${API_URL}/chats/requestingLeave/${chatUuid}`;
            await axios.put(url, { requestingLeave }, headers);
            Toast.success(
                requestingLeave
                    ? "Removal request sent to the group admin."
                    : "Removal request cancelled."
            );
        } catch (error) {
            Toast.error(error.getApiErrorDetails().message);
            throw error;
        } finally {
            setIsLeavingChat(false);
        }
    };

    return {
        isLeavingChat,
        leaveChat,
        requestToLeaveChat
    };
};